const initState = () => ({
  projects: [],
  tweets: [],
  loading: true,
  error: null,
});

export default initState;
